import React from 'react';

const HiddenInput = ({ name, value }) => (
  value ? <input type='hidden' name={name} value={value} /> : null
);

export default HiddenInput;
